import { Website } from "@Classes"

const website = new Website()
let currentClient = website.getCurrentWebsite()

export default currentClient;